export const SkeletonPortofolio = () => {
  return (
    <div className="space-y-8 animate-pulse">
      {/* HEADER SKELETON */}
      <div className="flex items-center gap-3 border-b border-slate-200 dark:border-slate-800 pb-4">
        <div className="w-6 h-6 bg-slate-200 dark:bg-slate-800 rounded-md" />
        <div className="space-y-2">
          <div className="h-6 w-32 bg-slate-200 dark:bg-slate-800 rounded-md" />
          <div className="h-4 w-64 bg-slate-200 dark:bg-slate-800 rounded-md" />
        </div>
      </div>

      {/* CARDS GRID SKELETON */}
      {/* Kita buat 2 card skeleton berjajar agar sesuai dengan layout maksimal (Olahraga & Seni) */}
      <div className="grid gap-8 items-start lg:grid-cols-2 grid-cols-1">
        {[1, 2].map((card) => (
          <div
            key={card}
            className="bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 rounded-xl overflow-hidden shadow-sm flex flex-col"
          >
            {/* Card Header */}
            <div className="p-6 border-b border-slate-100 dark:border-slate-800 bg-slate-50/50 dark:bg-slate-900/50">
              <div className="flex items-center gap-3 mb-2">
                <div className="w-9 h-9 bg-slate-200 dark:bg-slate-800 rounded-lg" />
                <div className="h-5 w-40 bg-slate-200 dark:bg-slate-800 rounded-md" />
              </div>
              <div className="flex gap-2 mt-4">
                <div className="h-8 w-24 bg-slate-200 dark:bg-slate-800 rounded-md" />
                <div className="h-8 w-24 bg-slate-200 dark:bg-slate-800 rounded-md" />
              </div>
            </div>

            {/* Card Body (List Berkas) */}
            <div className="p-6 space-y-6 flex-1">
              {[1, 2].map((item) => (
                <div
                  key={item}
                  className="relative pl-6 border-l-2 border-slate-200 dark:border-slate-800 last:pb-0 pb-6"
                >
                  {/* Step Indicator */}
                  <div className="absolute -left-[9px] top-0 w-4 h-4 rounded-full border-2 border-slate-200 dark:border-slate-700 bg-slate-100 dark:bg-slate-800" />

                  <div className="space-y-3">
                    {/* Title & Desc */}
                    <div>
                      <div className="h-5 w-3/4 bg-slate-200 dark:bg-slate-800 rounded-md mb-2" />
                      <div className="h-3 w-full bg-slate-200 dark:bg-slate-800 rounded-md mb-1.5" />
                      <div className="h-3 w-5/6 bg-slate-200 dark:bg-slate-800 rounded-md" />

                      {/* Badges */}
                      <div className="flex gap-2 mt-3">
                        <div className="h-5 w-10 bg-slate-200 dark:bg-slate-800 rounded-md" />
                        <div className="h-5 w-16 bg-slate-200 dark:bg-slate-800 rounded-md" />
                      </div>
                    </div>

                    {/* Upload Box */}
                    <div className="p-4 rounded-lg border border-dashed border-slate-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-950/50">
                      <div className="flex flex-col gap-3">
                        <div className="flex items-center justify-between gap-3">
                          <div className="h-4 w-32 bg-slate-200 dark:bg-slate-800 rounded-md" />
                          <div className="h-8 w-20 bg-slate-200 dark:bg-slate-800 rounded-md" />
                        </div>
                        <div className="flex items-center justify-end border-t border-slate-200/50 dark:border-slate-700/50 pt-3 mt-1">
                          <div className="h-8 w-24 bg-slate-200 dark:bg-slate-800 rounded-md" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
